import axios from 'axios';
//import config from '../../config/api';

//const API_URL = config.API_URL + '/rooms';
const API_URL = process.env.VUE_APP_API_URL + '/rooms';
const state = {
    rooms: [],
};
const getters = {
    rooms: (state) => state.rooms,
};
const actions = {
    async fetchRooms({ commit}) {
        const response = await axios.get(`${API_URL}/ending-seminars`);
        commit('setRooms', response.data);
    },
    async fetchAndMapHashes({ commit, dispatch, rootGetters, getters}) {
        await dispatch('fetchHashes', getters.rooms.map(({seminarDateId}) => seminarDateId));
        commit('setRoomHashes', rootGetters.hashes); 
    }
};
const mutations = {
    setRooms: (state, rooms) => state.rooms = rooms,
    setRoomHashes: (state, hashes) => state.rooms = state.rooms.map(room => ({ ...room, seminarDateHash: hashes[room.seminarDateId] || null}))
};

export default {
    state,
    getters,
    actions,
    mutations,
}